import React from 'react';
import Grid from '@material-ui/core/Grid';
import { PrepAndProdImageThumbnail } from '../../../features/PpiContainer/constants';
import StepInstructionsField from '../../Form/Fields/StepInstructionsField';
import StepContent from './StepContent';

const StepByStepTabContent = () => {
  return (
    <Grid container spacing={4}>
      <StepInstructionsField
        dataField="prepAndProdSteps"
        StepContent={StepContent}
        thumbnailHeight={PrepAndProdImageThumbnail.Height}
        thumbnailWidth={PrepAndProdImageThumbnail.Width}
        useMultiInstructions
      />
    </Grid>
  );
};

export default StepByStepTabContent;
